import _implicitStylesheets from "./highlights.css";
import _implicitScopedStylesheets from "./highlights.scoped.css?scoped=true";
import {freezeTemplate, parseFragment, registerTemplate} from "lwc";
const $fragment1 = parseFragment`<h3 type-style="display-6"${3}>${"t1"}</h3>`;
const $fragment2 = parseFragment`<div type-style="body-2" class="highlight${0}"${"a0:size"}${2}><div class="divider${0}"${2}></div><p${3}>${"t3"}</p></div>`;
const stc0 = {
  attrs: {
    "grid": "",
    "align-items": "start",
    "flow": "wrap",
    "gap": "x-large",
    "row-gap": "x-large"
  },
  key: 2
};
function tmpl($api, $cmp, $slotset, $ctx) {
  const {d: api_dynamic_text, sp: api_static_part, st: api_static_fragment, k: api_key, i: api_iterator, h: api_element} = $api;
  return [api_static_fragment($fragment1, 1, [api_static_part(1, null, api_dynamic_text($cmp.highlightsLabel))]), api_element("div", stc0, api_iterator($cmp.formattedHighlights, function (highlight) {
    return api_static_fragment($fragment2, api_key(4, highlight), [api_static_part(0, {
      attrs: {
        "size": $cmp.gridSize
      }
    }, null), api_static_part(3, null, api_dynamic_text(highlight))]);
  }))];
  /*LWC compiler v7.1.3*/
}
export default registerTemplate(tmpl);
tmpl.stylesheets = [];
tmpl.stylesheetToken = "lwc-27pornr90ch";
tmpl.legacyStylesheetToken = "undefined-_highlights";
if (_implicitStylesheets) {
  tmpl.stylesheets.push.apply(tmpl.stylesheets, _implicitStylesheets);
}
if (_implicitScopedStylesheets) {
  tmpl.stylesheets.push.apply(tmpl.stylesheets, _implicitScopedStylesheets);
}
freezeTemplate(tmpl);
